import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MasterService } from './Shared/app.Masters.Service';
import devtools from 'devtools-detect';
import { BnNgIdleService } from 'bn-ng-idle';
import { PresenceService } from '../../src/app/_Chatbox/_service/presence.service';
import { TableAlignmentService } from './Shared/table-alignment.service';
declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./../assets/Content/vendor/bootstrap/css/bootstrap.min.css',
        './../assets/Content/vendor/metisMenu/metisMenu.min.css',
        './../assets/Content/dist/css/sb-admin-2.css',
        './../assets/Content/vendor/font-awesome/css/font-awesome.min.css'
    ],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'FINNAUX TECHSOLUTIONS PRIVATE LIMITED';
  private previousUrl: string = '';

  constructor(
    private _Route: Router, 
    private _masterService: MasterService, 
    private bnIdle: BnNgIdleService, 
    private presenceService: PresenceService,
    private tableAlignmentService: TableAlignmentService
  ) {
    this.bnIdle.startWatching(1800).subscribe((res) => {
      if (res) {
        sessionStorage.removeItem('currentUser');
        sessionStorage.clear();
        this.presenceService.currentUser.next(null);

        this._Route.navigate(['Login']);
      }
    })
  }

  ngOnInit() {
    this.tableAlignmentService.init();

    // 1. Capture sidebar scroll position whenever a user interacts with or clicks any link in the sidebar
    $(document).on('mousedown click', '#sidebar-wrapper a', function () {
      const sidebar = document.getElementById('sidebar-wrapper');
      if (sidebar && sidebar.scrollTop > 0) {
        sessionStorage.setItem('sidebar_scroll_pos', sidebar.scrollTop.toString());
      }
    });

    // 2. Continuous scroll position persistence while scrolling sidebar
    $(document).on('scroll', '#sidebar-wrapper', function () {
      const st = $(this).scrollTop();
      if (st > 0) {
        sessionStorage.setItem('sidebar_scroll_pos', st.toString());
      }
    });

    // 3. Smart Sidebar Scroll Management on Route Navigation
    let scrollRestoreTimer: any = null;

    this._Route.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const prevUrl = (this.previousUrl || '').toLowerCase();
      const isComingFromHome = !this.previousUrl || 
                               prevUrl.includes('/home') || 
                               prevUrl.includes('/index/page') || 
                               prevUrl === '/' || 
                               prevUrl.includes('/login');

      // Update previous URL for subsequent navigations
      this.previousUrl = event.urlAfterRedirects || event.url;

      if (scrollRestoreTimer) {
        clearInterval(scrollRestoreTimer);
        scrollRestoreTimer = null;
      }

      if (isComingFromHome) {
        // Navigating fresh FROM Home into any page: Clear saved scroll and ALWAYS start at TOP
        sessionStorage.removeItem('sidebar_scroll_pos');
        setTimeout(() => {
          const sidebar = document.getElementById('sidebar-wrapper');
          if (sidebar) sidebar.scrollTop = 0;
        }, 50);
      } else {
        // Navigating within module / clicking submenus:
        // Poll repeatedly until Angular renders the async menu items and the scroll offset is applied
        const savedPosStr = sessionStorage.getItem('sidebar_scroll_pos');
        const targetScroll = savedPosStr ? parseInt(savedPosStr, 10) : 0;
        let attempts = 0;

        scrollRestoreTimer = setInterval(() => {
          attempts++;
          const sidebar = document.getElementById('sidebar-wrapper');
          const activeLink = document.querySelector('#sidebar-wrapper .nav-bar-active, #sidebar-wrapper a.active, #sidebar-wrapper li.active > a') as HTMLElement;

          if (sidebar) {
            if (targetScroll > 0) {
              sidebar.scrollTop = targetScroll;
              // If scroll position is successfully applied or max attempts reached, stop polling
              if (sidebar.scrollTop >= targetScroll - 10 || attempts > 30) {
                clearInterval(scrollRestoreTimer);
                scrollRestoreTimer = null;
              }
            } else if (activeLink) {
              activeLink.scrollIntoView({ block: 'nearest', behavior: 'auto' });
              if (attempts > 30) {
                clearInterval(scrollRestoreTimer);
                scrollRestoreTimer = null;
              }
            } else if (attempts > 30) {
              clearInterval(scrollRestoreTimer);
              scrollRestoreTimer = null;
            }
          } else if (attempts > 30) {
            clearInterval(scrollRestoreTimer);
            scrollRestoreTimer = null;
          }
        }, 50);
      }
    });

    $(document).on('click', '#sidebar-toggle', function (e) {
      e.preventDefault();
      const wrapper = document.querySelector('#wrapper');
      if (wrapper) {
        wrapper.classList.toggle('toggled');
        // Only toggle sidebar-open backdrop class on mobile screen widths (<= 991px)
        if (window.innerWidth <= 991) {
          if (wrapper.classList.contains('toggled')) {
            document.body.classList.add('sidebar-open');
          } else {
            document.body.classList.remove('sidebar-open');
          }
        }
      }
    });

    $(document).on('click', '.sidebar-mobile-backdrop', function (e) {
      e.preventDefault();
      document.querySelector('#wrapper')?.classList.remove('toggled');
      document.body.classList.remove('sidebar-open');
    });

    $(document).on('click', '#sidebar-wrapper a', function (e) {
      // Only close on mobile (width <= 991px) and only if it's a direct navigation link (not a parent menu dropdown)
      if (window.innerWidth <= 991 && !$(this).parent().hasClass('side-bar-dropdown')) {
        document.querySelector('#wrapper')?.classList.remove('toggled');
        document.body.classList.remove('sidebar-open');
      }
    });

    // 4. Global Nested / Stacked Modal Management for Bootstrap
    // a) Stop click propagation on modal close/dismiss buttons so parent modal doesn't also receive the dismiss event
    $(document).on('click', '.modal [data-dismiss="modal"], .modal .close', function (e: any) {
      e.stopPropagation();
      const currentModal = $(this).closest('.modal');
      if (currentModal.length) {
        currentModal.modal('hide');
      }
    });

    // b) When any modal is hidden, check if other modals are still open; if so, keep body.modal-open active
    $(document).on('hidden.bs.modal', '.modal', function (e: any) {
      e.stopPropagation();
      if ($('.modal:visible').length > 0) {
        $('body').addClass('modal-open');
      }
    });

    // c) Manage z-index dynamically when multiple modals are opened
    $(document).on('show.bs.modal', '.modal', function () {
      const openModalsCount = $('.modal:visible').length;
      if (openModalsCount > 0) {
        const nextZIndex = 1050 + (20 * openModalsCount);
        $(this).css('z-index', nextZIndex);
        setTimeout(() => {
          $('.modal-backdrop').not('.modal-stack').css('z-index', nextZIndex - 1).addClass('modal-stack');
        }, 0);
      }
    });
    if (environment.production) {
      var allow;
      if (isNaN(+allow)) allow = 100;
      var start = +new Date();
      debugger;
      var end = +new Date();
      if (isNaN(start) || isNaN(end) || end - start > allow) {
        this._Route.navigate([`Page403Error`]);
      }

    }
    //if ( devtools.isOpen) 
    //  {
    //  this._Route.navigate([`Page403Error`]);
    //  }

    if (environment.production) {

      document.addEventListener('contextmenu', (e) => e.preventDefault());

      function ctrlShiftKey(e, keyCode) {
        return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
      }
      document.onkeydown = (e) => {
        if (
          e.keyCode === 123 ||
          ctrlShiftKey(e, 'I') ||
          ctrlShiftKey(e, 'J') ||
          ctrlShiftKey(e, 'C') ||
          (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
        )
          return false;
      };
      document.addEventListener('contextmenu',
        event => event.preventDefault());

      window.addEventListener("keyup", kPress, false);
      function kPress(e) {
        var c = e.keyCode || e.charCode;
        if (c == 44) event.preventDefault();
      }

      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }

    
    this._masterService.CheckMACAllowed({"MacAddresss":this._masterService.getMacAddress()}).subscribe(response=>{
      if(!(response[0]["CODE"]==0 && response[0]["MSG"]=="Allow")){
        this._Route.navigate([`Page403Error`]);
      }
      console.log("H Start h",response)
    })


  }

  
}
